import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: true
})
export class LoaderComponent {
  spinnerColor = input<string>('#fff');
  baseColor = input<string>('rgba(255, 255, 255, 0.3)');
  loaderSize = input<string>('24px');
  borderSize = input<string>('2px');
  /** Texte lu par les lecteurs d'écran pendant le chargement. */
  label = input<string>('Chargement en cours');
}